export default {
  confirm: {
    en: 'Confirm',
  },
  resubscribeNow: {
    en: 'Resubscribe now',
  },
  gift: {
    en: 'Gift',
  },
  queueLabel: {
    en: 'Shipping from your queue. You can change it after resubscribe.',
  },
  title: {
    en: 'You\'re almost done!',
  },
  queueTitle: {
    en: 'Please reactivate your subscription to add to your queue',
  },
  text: {
    en: 'By clicking "Resubscribe now", you are agreeing to resubscribe to Scentbird for $14.95 a month.',
  },
  queueText: {
    en: 'In order to update your queue, you\'ll need to resubscribe to Scentbird.',
  },

  resubfreeproduct: {
    text: {
      en: 'By clicking "Confirm", you are agreeing to resubscribe to Scentbird for $14.95 a month, and get a <b>free gift</b> in your next order.',
    },
    queueText: {
      en: 'In order to update your queue, you\'ll need to resubscribe to Scentbird. We\'ll sweeten the deal by throwing a free gift into your next order.',
    },
  },
}
